export type NewcomerRewardStatus = 'pending' | 'settled' | 'failed';
export type NewcomerRewardRange = '' | '7d' | 'month';

export interface NewcomerRewardDTO {
  market_id?: string;
  amount_display?: string;
  withdrawal_account_bound?: boolean;
  id: number;
  user_id: number;
  user_nickname: string;
  registered_at: string;
  status: NewcomerRewardStatus;
  alipay_bound: boolean;
  apple_verified: boolean;
  first_task_approved: boolean;
  first_approved_assignment_id?: number;
  attempt_count: number;
  failure_reason: string;
  amount_fen: number;
  amount_yuan: string;
  last_checked_at?: string;
  settled_at?: string;
}

export interface NewcomerRewardListResponseDTO {
  total: number;
  page: number;
  page_size: number;
  items: NewcomerRewardDTO[];
}

export const NEWCOMER_REWARD_STATUS_LABELS: Record<NewcomerRewardStatus, string> = {
  pending: '待满足',
  settled: '已发放',
  failed: '发放失败',
};

export const NEWCOMER_REWARD_RANGE_LABELS: Record<NewcomerRewardRange, string> = {
  '': '全部时间',
  '7d': '近7天',
  month: '本月',
};

export const ALL_NEWCOMER_REWARD_STATUSES: Array<NewcomerRewardStatus | ''> = ['', 'pending', 'settled', 'failed'];
export const ALL_NEWCOMER_REWARD_RANGES: NewcomerRewardRange[] = ['', '7d', 'month'];
